import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import { PageFrame } from "@/components/common";
import { CustomerSupportChatsPanel } from "./CustomerSupportChatsPanel";

export default function AdminChatsPage() {
  const { t } = useTranslation("support");

  return (
    <PageFrame
      title={t("adminHub.chatsTab")}
      description={t("adminHub.chatsDescription")}
      icon={MessageCircle}
      className="min-h-0 flex-1 overflow-hidden"
    >
      <CustomerSupportChatsPanel />
    </PageFrame>
  );
}
